import axios from "axios";
import { isISODate } from "@/lib/dates";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function getCategories() {
  const { data } = await axios.get(`${API}/training/categories`);
  return data.categories || [];
}

export async function getCategory(key) {
  const { data } = await axios.get(`${API}/training/categories/${key}`);
  return data;
}

export async function getEligibility(category, age) {
  const { data } = await axios.get(`${API}/training/eligibility`, { params: { category, age } });
  return data;
}

export async function joinClassAlert(body) {
  const { data } = await axios.post(`${API}/training/class-alerts`, body);
  return data;
}

export async function getSiteContent() {
  const { data } = await axios.get(`${API}/site-content`);
  return data;
}

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const parts = (s) => s.split("-").map(Number);
export function weekday(s) {
  if (!isISODate(s)) return "";
  const [y, m, d] = parts(s);
  return DAYS[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
}
export function longDate(s) {
  if (!isISODate(s)) return s || "";
  const [y, m, d] = parts(s);
  return `${weekday(s)}, ${MONTHS[m - 1]} ${d}, ${y}`;
}
export function shortDate(s) {
  if (!isISODate(s)) return s || "";
  const [, m, d] = parts(s);
  return `${MONTHS[m - 1].slice(0, 3)} ${d}`;
}
export const timeRange = (o) => [o.time, o.end_time].filter(Boolean).join(" – ");
export const usd = (v) => `$${Number(v || 0).toFixed(2).replace(/\.00$/, "")}`;
export const FORMAT_INFO = {
  trial: { label: "One-Day Trial Workout", short: "One-Day Trial", blurb: "A single workout. No four-week commitment." },
  four_week: { label: "Four-Week Training Program", short: "Four-Week Program", blurb: "Full 4-week program, or drop in for a single class." },
  dropin: { label: "Single-Class Drop-In", short: "Drop-In", blurb: "One class, no commitment. Book at least 24 hours ahead. Four drop-ins cost $160 — a four-week program is $140." },
  lesson: { label: "Private Lesson", short: "Private Lesson", blurb: "One-on-one coaching." },
};
export const isOpen = (o) => o.display_status === "open" || o.display_status === "limited";

export function opensLabel(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.toLocaleString("en-US", { timeZone: "America/Chicago", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })} CT`;
}

export function statusLabel(o) {
  if (o.display_status === "limited") return { text: `${o.remaining} ${o.remaining === 1 ? "spot" : "spots"} left`, tone: "warn" };
  if (o.display_status === "open") return { text: "Available", tone: "ok" };
  if (o.display_status === "full") return { text: "Full", tone: "muted" };
  if (o.display_status === "closed") return { text: "Registration closed", tone: "muted" };
  return { text: o.opens_at ? `Opens ${opensLabel(o.opens_at)}` : "Coming soon", tone: "muted" };
}
